<template>
  <div class="teams-page">
    <div v-if="loaded && teams.length === 0" class="empty-teams">
      Нет доступных команд. Создайте команду или попросите доступ у владельца.
    </div>
    <div v-if="serviceIsReady()" class="teams-page__content">
      <div class="teams">
        <div v-if="!singleTeamMode" class="teams-table-block">
          <q-table
              flat
              bordered
              class="data-table"
              title="Команды"
              :rows="teams"
              :columns="teamsTableColumns"
              :pagination="teamTablePagination"
              :loading="teams.length === 0"
              row-key="name"
              binary-state-sort
          >
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td v-ripple key="name" :props="props">
                  <span class="clickable">{{ props.row.name }}</span>
                  <q-popup-edit v-model="props.row.name" title="Изменить имя" auto-save v-slot="scope">
                    <q-input v-model="scope.value" dense autofocus counter @keyup.enter="scope.set(); changeTeamField(props.row.id, 'name' ,props.row.name)" />
                  </q-popup-edit>
                </q-td>
                <q-td v-ripple key="messenger_group_id" :props="props">
                  <span class="clickable">{{ props.row.messengerGroupId }}</span>
                  <q-popup-edit v-model="props.row.messengerGroupId" title="Изменить ID группы в месседжере" auto-save v-slot="scope">
                    <q-input v-model="scope.value" dense autofocus counter @keyup.enter="scope.set(); changeTeamField(props.row.id, 'messenger_group_id' ,props.row.messengerGroupId)" />
                  </q-popup-edit>
                </q-td>
                <q-td v-ripple key="messenger_thread_id" :props="props">
                  <span class="clickable">{{ props.row.messengerThreadId }}</span>
                  <q-popup-edit v-model="props.row.messengerThreadId" title="Изменить ID треда в Telegram" auto-save v-slot="scope">
                    <q-input v-model="scope.value" dense autofocus counter @keyup.enter="scope.set(); changeTeamField(props.row.id, 'messenger_thread_id' ,props.row.messengerThreadId)" />
                  </q-popup-edit>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
        <div class="team" v-for="team in teams" :key="team.getId()">
          <div class="team-inner-block team-section">
            <q-table
                flat
                bordered
                class="data-table"
                :title="team.getName()"
                :rows="team.getMembers()"
                :columns="teamTableColumns"
                :pagination="teamTablePagination"
                row-key="name"
                binary-state-sort
            >
              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td v-ripple key="name" :props="props">
                    <span class="clickable">{{ props.row.name }}</span>
                    <q-popup-edit v-model="props.row.name" title="Изменить имя" auto-save v-slot="scope">
                      <q-input v-model="scope.value" dense autofocus counter @keyup.enter="scope.set(); changePresenterField(props.row.getId(), 'name' ,props.row.name)" />
                    </q-popup-edit>
                  </q-td>
                  <q-td v-ripple key="messenger" :props="props">
                    <div class="clickable">
                      <span v-if="props.row.getMessenger()">@</span>{{ props.row.messenger }}
                    </div>
                    <q-popup-edit v-model="props.row.messenger" title="Изменить ник в мессенджере" auto-save v-slot="scope">
                      <q-input v-model="scope.value" dense autofocus counter @keyup.enter="scope.set(); changePresenterField(props.row.getId(), 'messenger_nick_name' ,props.row.messenger)" />
                    </q-popup-edit>
                  </q-td>
                  <q-td key="meetingTypes" :props="props">
                    <Multiselect
                        v-model="meetingTypesForMembers[props.row.getId()]"
                        @close="updateMeetingTypesForMember(props.row.getId())"
                        mode="tags"
                        placeholder="Select meeting types"
                        track-by="label"
                        label="label"
                        :searchable="true"
                        :close-on-select="false"
                        :options="optionsForTeam(team.getId())"
                    >
                      <template v-slot:tag="{ option, handleTagRemove, disabled }">
                        <div
                            class="multiselect-tag is-user"
                            :class="{
            'is-disabled': disabled
          }"
                        >
                          {{ option.label }}
                          <span
                              v-if="!disabled"
                              class="multiselect-tag-remove"
                              @click="handleTagRemove(option, $event)"
                          >
            <span class="multiselect-tag-remove-icon"></span>
          </span>
                        </div>
                      </template>
                    </Multiselect>
                  </q-td>
                  <q-td key="isOnVacation" :props="props">
                    <q-toggle v-model="props.row.isOnVacation"
                              @update:model-value="toggleOnVacationState(props.row.getId())"
                    />
                  </q-td>
                  <q-td class="remove-presenter-icon" key="removePresenter" :props="props">
                    <q-btn flat round color="negative" @click="removePresenter(props.row.getId())">
                      <font-awesome-icon icon="fa-solid fa-circle-minus" />
                    </q-btn>
                  </q-td>
                </q-tr>
              </template>
            </q-table>
            <div class="new-presenter-form">
              <q-input dense outlined v-model="newPresenters[team.getId()]" label="Имя" />
              <q-input dense outlined v-model="newPresenterNickNames[team.getId()]" label="Ник в мессенджере" />
              <q-btn no-caps unelevated @click="addPresenter(newPresenters[team.getId()], newPresenterNickNames[team.getId()], team.getId())" color="primary" label="Добавить ведущего" />
            </div>
          </div>
          <div class="team-rotation-block team-section">
            <q-table
                flat
                bordered
                class="data-table"
                :title="currentSprintName"
                :rows="getRotationData(team)"
                :columns="rotationTableColumns"
                :pagination="teamTablePagination"
                row-key="key"
                binary-state-sort
            >
              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td v-ripple key="meetingType" :props="props">
                    <span>{{ props.row.meetingType }}</span>
                  </q-td>
                  <q-td v-ripple key="scheduledDate" :props="props">
                    <span>{{ formatRotationDate(props.row.scheduledDate) }}</span>
                  </q-td>
                  <q-td v-ripple key="presenter" :props="props">
                    <span>{{ props.row.presenter }}</span>
                  </q-td>
                  <q-td class="remove-presenter-icon">
                    <q-btn flat round color="primary" @click="rotatePresenterForTeamAndMeetingType(team, props.row.meetingTypeId)">
                      <font-awesome-icon icon="fa-solid fa-arrows-rotate" />
                    </q-btn>
                  </q-td>
                </q-tr>
              </template>
            </q-table>
            <div class="rotation-notification-row">
              <q-checkbox
                  v-model="sendSingleRotationNotification"
                  label="Отправлять уведомление в Telegram при ротации"
              />
            </div>
            <q-btn no-caps unelevated class="rotation-button" @click="rotatePresentersForTeam(team)" color="primary" label="Ротировать всех ведущих"  />
          </div>
        </div>
      </div>
    </div>
    <q-spinner-cube
        class="teams-spinner"
        v-if="!loaded"
        color="green"
        size="5.5em"
    />
  </div>
</template>

<script>
import grpc from "@/services/grpc";
import Multiselect from '@vueform/multiselect'
import Member from "@/models/Member";
import Team from "@/models/Team";
import RotationTeamData from "@/models/RotationTeamData";
import MeetingTypeToPresenter from "@/models/MeetingTypeToPresenter";

const teamsTableColumns = [
  {
    name: 'name',
    required: true,
    label: 'Имя',
    align: 'left',
    field: row => row.getName(),
    format: val => `${val}`,
    sortable: true
  },
  { name: 'messenger_group_id', align: 'center', label: '№ группы в мессенджере', field: 'messenger_group_id'},
  { name: 'messenger_thread_id', align: 'center', label: '№ треда в Telegram', field: 'messenger_thread_id'},
];
const teamTableColumns = [
  {
    name: 'name',
    required: true,
    label: 'Имя',
    align: 'left',
    field: row => row.getName(),
    format: val => `${val}`,
    sortable: true
  },
  { name: 'messenger', align: 'center', label: 'Ник в мессенджере', field: row => row.getMessenger(), sortable: true },
  { name: 'meetingTypes', label: 'Типы встреч', field: 'meetingTypes' },
  { name: 'isOnVacation', label: 'В отпуске', field: 'isOn_vacation' },
  { name: 'removePresenter', label: 'Удалить ведущего', field: 'id' },
];
const rotationTableColumns = [
  { name: 'meetingType', label: 'Типы встречи', field: 'meetingType' },
  { name: 'scheduledDate', label: 'Дата', field: 'scheduledDate', sortable: true },
  { name: 'presenter', label: 'Ведущий', field: 'presenter' },
  { name: 'rotate', label: 'Ротировать' },
]

const teamTablePagination = {
  sortBy: 'asc',
  descending: false,
  rowsPerPage: 0
};

export default {
  name: 'TeamsBlock',
  components: {
    Multiselect,
  },
  created() {
    this.initSingleMode(this.$route.params.id);
    this.initApp();
  },
  watch: {
    $route(to) {
      this.initSingleMode(to.params.id);
    }
  },
  data() {
    return {
      singleTeamId: null,
      singleTeamMode: false,
      grpcClient: new grpc(),
      newPresenters: [],
      newPresenterNickNames: [],
      loaded: false,
      teams: [],
      meetingTypesForMembers: [],
      meetingTypeOptionsByTeam: {},
      teamsTableColumns: teamsTableColumns,
      teamTableColumns: teamTableColumns,
      teamTablePagination: teamTablePagination,
      rotationTableColumns: rotationTableColumns,
      rotationData: [],
      currentSprintName: '',
      sendSingleRotationNotification: true,
    };
  },
  methods: {
    async initApp() {
      try {
        await this.getTeams();
        this.getCurrentSprintName();
      } finally {
        this.loaded = true;
      }
    },
    optionsForTeam(teamId) {
      return this.meetingTypeOptionsByTeam[teamId] || [];
    },
    async getTeams() {
      const teams = await this.grpcClient.getTeams();
      this.teams = [];
      this.meetingTypesForMembers = [];
      for (let team of teams) {
        const teamToAdd = new Team(team.getId(), team.getName(), team.getMessengerGroupId(), team.getMessengerThreadId());
        const members = await this.grpcClient.getPresenters(team.getId());
        for (let member of members) {
          const memberToAdd = new Member(
              member.getId(),
              member.getName(),
              member.getMessengerNickName(),
              member.getMeetingTypesList(),
              member.getIsOnVacation()
          );
          teamToAdd.addMember(memberToAdd);
          for (let meetingType of member.getMeetingTypesList()) {
            if (!this.meetingTypesForMembers[member.getId()]) {
              this.meetingTypesForMembers[member.getId()] = [];
            }
            this.meetingTypesForMembers[memberToAdd.getId()].push(meetingType.getId());
          }
        }
        if (this.showTeam(teamToAdd)) {
          this.teams.push(teamToAdd);
          await this.getMeetingTypes(teamToAdd.getId());
          await this.setRotationData(teamToAdd);
        }
      }
    },
    async getMeetingTypes(teamId) {
      const meetingTypes = await this.grpcClient.getMeetingTypes(teamId)
      this.meetingTypeOptionsByTeam[teamId] = meetingTypes.map(meetingType => ({
        label: meetingType.getName(),
        value: meetingType.getId()
      }));
    },
    async addPresenter(name, nickname, teamId) {
      if (!name) {
        return;
      }
      const presenter = await this.grpcClient.createPresenter(name, nickname, teamId);
      if (presenter.getId() > 0) {
        this.addNewPresenterToTeam(teamId, presenter, nickname);
      }
      delete (this.newPresenters[teamId]);
      delete (this.newPresenterNickNames[teamId]);
    },
    async removePresenter(memberId) {
      const status = await this.grpcClient.deletePresenter(memberId);
      if (status) {
        this.removeMemberFromTeam(memberId);
      }
    },
    removeMemberFromTeam(memberId) {
      for (let team of this.teams) {
        for (let member of team.getMembers()) {
          if (member.getId() === memberId) {
            team.members.splice(team.members.indexOf(member), 1);
          }
        }
      }
    },
    updateMeetingTypesForMember(memberId) {
      let meetingTypes = this.meetingTypesForMembers[memberId];
      this.grpcClient.updateMeetingTypesForMember(memberId, meetingTypes);
    },
    getCurrentSprintName() {
      this.grpcClient.getCurrentSprintName().then(name => {
        this.currentSprintName = name;
      });
    },
    addNewPresenterToTeam(teamId, presenter, nickname) {
      const member = new Member(
          presenter.getId(),
          presenter.getName(),
          nickname,
          this.meetingTypesForMembers[teamId]
      );
      this.teams.find(team => team.getId() === teamId).addMember(member);
    },
    changePresenterField(presenterId, fieldName, value) {
      this.grpcClient.changePresenterField(presenterId, fieldName, value);
    },
    changeTeamField(teamId, fieldName, value) {
      this.grpcClient.changeTeamField(teamId, fieldName, value);
    },
    getRotationData(team) {
      const data = [];
      if (this.rotationData[team.getId()]) {
        for (let elem of this.rotationData[team.getId()].getPresentersToMeetingTypesData()) {
          data.push(elem);
        }
      }
      return data;
    },
    async setRotationData(teamToAdd) {
      let rotationData = new RotationTeamData(this.currentSprintName);
      await this.grpcClient.getRotationDataForTeam(teamToAdd.getId()).then(rotations => {
        for (let rotation of rotations) {
          console.log(rotation);
          const meetingTypeToPresenter = this.getMeetingTypeToPresenterFromRotation(rotation)
          rotationData.addPresentersToMeetingTypesData(meetingTypeToPresenter);
        }
      });
      this.rotationData[teamToAdd.getId()] = rotationData;
    },
    async rotatePresentersForTeam(team) {
      let rotationData = new RotationTeamData(this.currentSprintName);
      const rotations = await this.grpcClient.rotateTeamPresenters(
          team.getId(),
          this.sendSingleRotationNotification
      );
      for (let rotation of rotations) {
        const meetingTypeToPresenter = this.getMeetingTypeToPresenterFromRotation(rotation)
        rotationData.addPresentersToMeetingTypesData(meetingTypeToPresenter);
      }
      this.rotationData[team.getId()] = rotationData;
    },
    async rotatePresenterForTeamAndMeetingType(team, meetingTypeId) {
      await this.grpcClient.rotateTeamPresentersForMeetingType(
          team.getId(),
          meetingTypeId,
          this.sendSingleRotationNotification
      );
      await this.setRotationData(team)
    },
    getMeetingTypeToPresenterFromRotation(rotation) {
      return new MeetingTypeToPresenter(
          rotation.getMeetingType(),
          rotation.getMeetingTypeId(),
          rotation.getPresenter(),
          rotation.getScheduledDate()
      );
    },
    formatRotationDate(date) {
      if (!date) {
        return '';
      }
      const [year, month, day] = date.split('-');
      if (!year || !month || !day) {
        return date;
      }
      return `${day}.${month}.${year}`;
    },
    initSingleMode(teamId) {
      this.singleTeamId = parseInt(teamId);
      this.singleTeamMode = this.singleTeamId !== undefined && teamId !== null && !isNaN(teamId);
    },
    showTeam(team) {
      if (!this.singleTeamMode) {
        return true;
      }
      return team.getId() === this.singleTeamId;
    },
    serviceIsReady() {
      return this.loaded && this.teams.length > 0;
    },
    async toggleOnVacationState(presenterId) {
      return await this.grpcClient.toggleOnVacation(presenterId)
    }
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.q-table__middle.scroll {
  overflow: visible;
}
</style>
<style lang="scss" scoped>
.teams-page {
  min-height: 100%;
  background: #f6f8fb;
  padding: 28px 20px 48px;
}

.teams-page__content {
  width: 100%;
}

.teams {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 100%;
}

.teams-table-block {
  width: min(1120px, 100%);
}

.team {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: min(1120px, 100%);
  padding: 24px;
  background: #ffffff;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(20, 32, 51, 0.06);
}

.team-section {
  width: 100%;
}

.new-presenter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  padding: 16px;
  margin-top: 14px;
  background: #f9fbfd;
  border: 1px solid #e8edf4;
  border-radius: 8px;

  label {
    flex: 1 1 220px;
    min-width: 180px;
  }
}

.data-table {
  overflow: hidden;
  border-color: #e1e7ef;
  border-radius: 8px;

  :deep(.q-table__top) {
    justify-content: flex-start;
    min-height: 56px;
    padding: 14px 18px;
    border-bottom: 1px solid #eef2f7;
  }

  :deep(.q-table__title) {
    color: #202938;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0;
  }

  :deep(thead tr) {
    background: #f7f9fc;
  }

  :deep(th) {
    color: #546179;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0;
  }

  :deep(td) {
    color: #263244;
    font-size: 14px;
  }

  :deep(tbody tr:hover) {
    background: #fbfdff;
  }
}

.remove-presenter-icon {
  cursor: pointer;
}

.rotation-notification-row {
  display: flex;
  align-items: center;
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid #edf1f6;
}

.rotation-button {
  margin-top: 14px;
}

.clickable {
  cursor: pointer;
}

.teams-spinner {
  display: block;
  margin: 80px auto;
}

.empty-teams {
  margin: 40px auto;
  color: #546179;
}

@media (max-width: 720px) {
  .teams-page {
    padding: 16px 12px 32px;
  }

  .team {
    padding: 16px;
  }

  .new-presenter-form {
    padding: 12px;

    label {
      flex-basis: 100%;
    }
  }

  .rotation-button {
    width: 100%;
  }
}
</style>
